export default "__VITE_ASSET__CanWNNYW__"